// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { miniCartStyles } from "@west/App/Components/MiniCart/MiniCart";
import { color, styledScrollbar } from "@west/XDL/Utilities";
import { css } from "styled-components";

miniCartStyles.headerContainer = {
    css: css`
        padding: 13px 0;
    `,
};

miniCartStyles.container = {
    css: css`
        width: 618px;
    `,
};

miniCartStyles.messageWrapper = {
    css: css`
        padding: 0 21px 0 13px;
    `,
};

miniCartStyles.cartLinesContainer = {
    css: css`
        padding: 0 21px 0 13px;
        max-height: calc(100vh - 484px);
        overflow-x: hidden;
        ${styledScrollbar(6)}
        padding-bottom: 8px;

        & > div.mini-cartLine:first-child {
            margin-top: 0;
        }
    `,
};

miniCartStyles.cartLinesHeader = {
    container: {
        css: css`
            width: 100%;
            display: flex;
            padding: 0 39px 8px 13px;
        `,
    },
    description: {
        size: 12,
        weight: "bold",
        css: css`
            letter-spacing: 0;
            line-height: 14px;
            flex-basis: 356px;
        `,
    },
    qty: {
        size: 12,
        weight: "bold",
        css: css`
            letter-spacing: 0;
            line-height: 14px;
            flex-grow: 1;
        `,
    },
    priceUnit: {
        size: 12,
        weight: "bold",
        css: css`
            letter-spacing: 0;
            line-height: 14px;
        `,
    },
};

miniCartStyles.subTotalContainer = {
    css: css`
        display: flex;
        justify-content: flex-end;
        align-items: center;
        gap: 8px;
        padding: 13px;
        padding-right: 21px;
        border-top: 1px solid ${color("common.border")};
    `,
};

miniCartStyles.subTotalLabel = {
    size: 14,
    weight: "bold",
    css: css`
        letter-spacing: 0;
        line-height: 22px;
    `,
};

miniCartStyles.subTotalValue = {
    variant: "h3",
    css: css`
        margin-bottom: 0;
    `,
};

miniCartStyles.actions = {
    css: css`
        display: flex;
        align-items: center;
        gap: 14px;
        padding: 0 21px 0 13px;
        & > button {
            flex-grow: 1;
            margin-top: 0;
        }
    `,
};

miniCartStyles.viewCartButton = {
    variant: "tertiary",
    css: css`
        width: 100%;
    `,
};
